import { render, staticRenderFns } from "./UserFavorites.vue?vue&type=template&id=0daee816&"
import script from "./UserFavorites.vue?vue&type=script&lang=js&"
export * from "./UserFavorites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports